import { calcularExecucaoProjetos } from "./indicadoresPdm.mjs";

export const COLUNAS_EXECUCAO_MUNICIPIO_AREA = [
  "Unidade Regional",
  "Município",
  "Eixo Temático/Área-chave",
  "PDM(s)",
  "Quantidade Total de Ações",
  "Quantidade de Ações Executadas",
  "Percentual de Execução (%)",
];

function texto(valor) {
  return String(valor || "").trim();
}

function chaveTexto(valor) {
  return texto(valor)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("pt-BR");
}

function chaveProjeto(projeto, indice) {
  const idProjeto = Number(projeto?.idProjeto);
  return Number.isFinite(idProjeto) && idProjeto > 0
    ? `id:${idProjeto}`
    : `indice:${indice}`;
}

function percentualAcao(acao) {
  const valor = Number(acao?.progressoCalculado ?? acao?.percentualConclusao ?? acao?.progresso);
  return Number.isFinite(valor) ? Math.max(0, Math.min(100, Math.round(valor))) : 0;
}

export function consolidarExecucaoMunicipioArea(registros = []) {
  const grupos = new Map();

  registros.forEach((registro, registroIndice) => {
    const municipio = texto(registro?.municipio) || "Município não informado";
    const area = texto(registro?.area) || "Área-chave não informada";
    const idMunicipio = Number(registro?.idMunicipio);
    const chaveMunicipio = Number.isFinite(idMunicipio) && idMunicipio > 0
      ? `id:${idMunicipio}`
      : `nome:${chaveTexto(municipio)}`;
    const chave = `${chaveMunicipio}::${chaveTexto(area)}`;

    if (!grupos.has(chave)) {
      grupos.set(chave, {
        unidadeRegional: texto(registro?.unidadeRegional) || "-",
        municipio,
        area,
        pdms: new Set(),
        projetos: new Map(),
      });
    }

    const grupo = grupos.get(chave);
    const nomePdm = texto(registro?.pdm);
    if (nomePdm) grupo.pdms.add(nomePdm);

    (registro?.projetos || []).forEach((projeto, projetoIndice) => {
      const chave = chaveProjeto(projeto, `${registroIndice}:${projetoIndice}`);
      if (!grupo.projetos.has(chave)) grupo.projetos.set(chave, projeto);
    });
  });

  return Array.from(grupos.values())
    .map((grupo) => {
      const projetos = Array.from(grupo.projetos.values());
      let totalAcoes = 0;
      let acoesExecutadas = 0;

      projetos.forEach((projeto) => {
        const acoes = projeto?.acoes || [];
        totalAcoes += acoes.length || Number(projeto?.totalAcoes || 0);
        acoesExecutadas += acoes.filter((acao) => percentualAcao(acao) >= 100).length;
      });

      return {
        "Unidade Regional": grupo.unidadeRegional,
        "Município": grupo.municipio,
        "Eixo Temático/Área-chave": grupo.area,
        "PDM(s)": Array.from(grupo.pdms).join("; ") || "-",
        "Quantidade Total de Ações": totalAcoes,
        "Quantidade de Ações Executadas": acoesExecutadas,
        "Percentual de Execução (%)": calcularExecucaoProjetos(
          projetos,
          (projeto) => projeto?.execucao,
        ),
      };
    })
    .sort((a, b) =>
      a["Município"].localeCompare(b["Município"], "pt-BR") ||
      a["Eixo Temático/Área-chave"].localeCompare(b["Eixo Temático/Área-chave"], "pt-BR")
    );
}

export function criarWorkbookExecucaoMunicipioArea(XLSX, linhas = []) {
  const ws = XLSX.utils.json_to_sheet(linhas, {
    header: COLUNAS_EXECUCAO_MUNICIPIO_AREA,
  });
  const ultimaLinha = Math.max(1, linhas.length + 1);
  ws["!autofilter"] = { ref: `A1:G${ultimaLinha}` };
  ws["!cols"] = [
    { wch: 24 },
    { wch: 28 },
    { wch: 38 },
    { wch: 36 },
    { wch: 28 },
    { wch: 32 },
    { wch: 27 },
  ];

  for (let linha = 2; linha <= ultimaLinha; linha += 1) {
    const celulaPercentual = ws[`G${linha}`];
    if (celulaPercentual) celulaPercentual.z = '0"%"';
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Execução por Município e Área");
  return wb;
}
